define("shared/utils/get-hashtags", ["exports", "later/utils/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = getHashtags;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants"eaimeta@70e063a35619d71f

  /**
   * @module Utils
   * @extends Utils
   *
   *
   * Finds all hashtags in a given string, accounting for
   * whitespace, newlines, and emojis.
   *
   * @method getHashtags
   *
   * @param {String} str The string in which to find hashtags
   *
   * @returns {Array[String]} The list of hashtags found in the input string.
   */
  function getHashtags(str) {
    const matches = (str === null || str === void 0 ? void 0 : str.match(_constants.HASHTAG_REGEX)) || [];
    return matches.map(tag => tag.substr(1));
  }
});